import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Divider from "@material-ui/core/Divider";
import List from '@material-ui/core/List';
import Player from "./player"
import CircularProgress from '@material-ui/core/CircularProgress';
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => ({
	root: {
		"display": "flex",
		"flex-flow": "column",
		"flex": 1,
		"minHeight": 0,
		position: "relative",
	},
	top: {
		"flex": "0 1 auto",
		minHeight: "70px",
		height: "70px",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	loading: {
		position: "absolute",
		margin: "0 auto",
		left: "50%",
		top: "50%",
		marginLeft: "-20px",
		marginTop: "-40px",
	},
	select: {
		width: "120px",
		margin: "25px 35px",
		'& div:focus':{
			background: 'none'
		},
	},
	refresh:{
		margin: "0 35px",
		cursor: "pointer"
	},
	list: {
		overflowX: "auto",
		"flex": "1 1 auto",
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
	},
	moreButton: {
		textAlign: "center",
		padding: "20px",
		cursor: "pointer"
	},
	divider: {
		marginLeft: "100px",
	},
	currentPlayer: {
		"-webkit-box-shadow": "0px -6px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
		"box-shadow": "0px -6px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
	},

	"@media (max-width: 450px)": {
		divider: {
			marginLeft: "78px",
		},
	}
});

class RangingTab extends React.Component{
	state = {
		isDownloading: false,
	}

	componentDidMount() {
		const container = document.querySelector('#ranking-list');
		container.addEventListener('scroll', this.loadRankingIfAtBottom);
	}

	componentWillUnmount() {
		const container = document.querySelector('#ranking-list');
		container.removeEventListener('scroll', this.loadRankingIfAtBottom);
	}

	loadRankingIfAtBottom = ({ target }) => {
		if(this.state.isDownloading || this.props.isRankingLoading[this.props.selectedFieldName]){
			return
		}

		if(target.scrollTop + 100 > target.scrollHeight - target.offsetHeight){
			console.log("Ściąga");

			this.setState({isDownloading: true}, () => {
				setTimeout(() => this.setState({isDownloading: false}), 500)
			});

			this.props.fetchRanking(this.props.selectedFieldName, true)
		}
	};

	renderRankingList = (scoreName, list = []) => {
		return <List component="ul" className={this.props.classes.list}  id="ranking-list">
			{list.map((player, index) => {
				return (
					<div key={`player-key-${index}`}>
						<Player playerData={player} rank={index + 1} scoreName={scoreName} />
						<Divider variant="inset" className={this.props.classes.divider} />
					</div>
				)
			})}
			{/*<div className={this.props.classes.moreButton}*/}
			{/*onClick={() => this.props.fetchRanking(this.props.selectedFieldName, true)}*/}
			{/*>*/}
			{/*Więcej*/}
			{/*</div>*/}
		</List>
	};

	doesListExistAndNotEmpty = (list) => {
		return list && list.length > 0
	};


	render(){
		const { classes,
			selectedFieldName,
			scoreName,
			handleSelectionChange,
			rankingList,
			isRankingLoading,
			fetchRanking,
			activePlayerStats,
			activePlayerDisplayName,
			activePlayerAvatar,
			rankingLanguage,
			isAnonymous,
			menuItemValues,
			resetRanking } = this.props;

//Jeśli się nie ładuje to zaciągnij
		if(!this.doesListExistAndNotEmpty(rankingList[selectedFieldName]) && !isRankingLoading[selectedFieldName]){
			fetchRanking(selectedFieldName, false)
		}

		const activePlayer = {
			name: isAnonymous ? "You" : activePlayerDisplayName,
			img: isAnonymous ? getTranslation("image_ranking_anonymous_user_icon") : activePlayerAvatar,
			score: activePlayerStats[selectedFieldName] || 0,
			country: rankingLanguage
		};

		return (
			<div className={classes.root}>
				<div className={classes.top}>
					<Select
						className={classes.select}
						value={selectedFieldName}
						onChange={handleSelectionChange}
						disableUnderline={true}
					>
						<MenuItem value={menuItemValues[0]}>{getTranslation("ranking_select_today")}</MenuItem>
						<MenuItem value={menuItemValues[1]}>{getTranslation("ranking_select_this_week")}</MenuItem>
						<MenuItem value={menuItemValues[2]}>{getTranslation("ranking_select_all_time")}</MenuItem>
					</Select>
					<img
						className={classes.refresh}
						src={getTranslation("image_ranking_refresh")}
						onClick={resetRanking}/>
				</div>
				<Divider />
				{isRankingLoading[selectedFieldName] && <CircularProgress className={classes.loading}/>}
				{this.renderRankingList(scoreName, rankingList[selectedFieldName])}
				{rankingList[selectedFieldName] &&
				<div className={classes.currentPlayer}>
					<Player playerData={activePlayer} rank={null} scoreName={scoreName} />
				</div>}
			</div>

		);
	}


}

RangingTab.propTypes = {
	isAnonymous: PropTypes.bool.isRequired,

	scoreName: PropTypes.string.isRequired,
	selectedFieldName: PropTypes.string.isRequired,
	rankingLanguage: PropTypes.string.isRequired,
	activePlayerDisplayName: PropTypes.string.isRequired,
	activePlayerAvatar: PropTypes.string,

	classes: PropTypes.object.isRequired,
	rankingList: PropTypes.object.isRequired,
	isRankingLoading: PropTypes.object.isRequired,
	activePlayerStats: PropTypes.object.isRequired,

	handleSelectionChange: PropTypes.func.isRequired,
	fetchRanking: PropTypes.func.isRequired,
	resetRanking: PropTypes.func.isRequired,
};

export default withStyles(styles)(RangingTab);
